// @flow
import React from 'react';
import { Button, Form, Input } from 'reactstrap';
import CommentClient from '../../../../../application/models/products/reviews/comments/CommentClient';
import type { Comment } from '../../../../../application/models/products/reviews/comments/Comment';
import type { Review } from '../../../../../application/models/products/reviews/Review';
import {
  displayAxiosError,
  displayMessage,
} from '../../../../../application/views/commons/messages';

type Props = {
  visible: boolean,
  parent: ?Comment,
  review: Review,
  token: string,
  focus: boolean,
  onFinishPosting: (comment: Comment) => void,
};

type State = {
  comment: string,
};

export default class CommentForm extends React.Component<Props, State> {
  input: any;
  commentClient: CommentClient = new CommentClient();

  constructor(props: Props) {
    super(props);

    console.log('CommentForm', props.review);

    this.state = {
      comment: '',
    };
  }

  componentDidMount() {
    if (this.props.focus) {
      this.input.focus();
    }
  }

  onClickPost() {
    const { parent, review, token } = this.props;
    const { comment } = this.state;

    this.commentClient
      .post(review, parent != null ? parent.id : null, comment, token)
      .then(response => {
        this.setState({ comment: '' });
        this.props.onFinishPosting(response.data);
        displayMessage('コメントしました');
      })
      .catch(error => {
        if (error.response.status === 400) {
          displayMessage(error.response.data.message);
        } else {
          displayAxiosError(error);
        }
      });
  }

  render(): React$Node {
    const { visible, parent } = this.props;
    const { comment } = this.state;

    if (!visible) {
      return null;
    }

    return (
      <div className="comment-form">
        <Form>
          <div className="input-group">
            <Input
              ref={input => (this.input = input)}
              type="textarea"
              className="comment-input"
              value={comment}
              placeholder={
                parent != null
                  ? `${parent.user.name}さんに返信`
                  : '参考になりました！などをコメントしてみましょう'
              }
              onChange={e => this.setState({ comment: e.target.value })}
            />
            <div className="submit-wrap">
              <Button
                className="comment-submit"
                color="primary"
                onClick={() => this.onClickPost()}
              >
                <i className="fa fa-pencil-square-o"></i>
                送信
              </Button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}
